<template>
<div>
    <AdminSidebar
        v-if="$store.state.user.userAdm || $store.state.user.companyType == 3"
        :url="url"
        :selected="this.$route.name"
        hideFomentation
    >
        <component :is="logos[getWhiteLabel]" />
        <PoweredBy v-if="getWhiteLabel === 'TECBAN'" stroke="none" />
    </AdminSidebar>


    <SponsorSidebar
        hideFomentation
        v-else-if="$store.state.user.type == 0 && $store.state.user.companyType == 0"
        :url="url" 
        :selected="this.$route.name"
        :accessLevel="$store.state.user.accessLevel.toString()"
        :cnpjId="$store.state.user.cnpjId.toString()"
        :notification="$store.state.user.notifications"
        :whiteLabel="getWhiteLabel"
    >
        <component :is="logos[getWhiteLabel]" />
        <PoweredBy v-if="getWhiteLabel === 'TECBAN'" stroke="none" />
    </SponsorSidebar>

    <ProviderSidebar
        hideFomentation
        @workingCapital="handleFinancingDialog('Capital de giro')"
        @contractsProjects="handleFinancingDialog('Contratos e projetos')"
        v-else-if="$store.state.user.type == 1 && $store.state.user.companyType == 1"
        :url="url"
        :selected="this.$route.name"
        :accessLevel="$store.state.user.accessLevel.toString()"
        :cnpjId="$store.state.user.cnpjId.toString()"
        :availableToFomentation="$store.state.user.availableToFomentation"
        :availableToMarketplace="$store.state.user.availableToMarketplace"
        :orderAntecipationMode="$store.state.user.orderAntecipationMode"
        :canAnticipate="$store.state.user.canOperate"
        :hasBuyerValidation="$store.state.user.availableToXmlAnticipation"
        :availableToBalanceAnticipation="$store.state.user.availableToBalanceAnticipation"
        :availableToRequestValueForAnticipation="$store.state.user.availableToRequestValueForAnticipation"
        :notification="$store.state.user.notifications"
    >
        <component :is="logos[getWhiteLabel]" />
        <PoweredBy v-if="getWhiteLabel === 'TECBAN'" stroke="none" />
    </ProviderSidebar>

    <BuyerSidebar
        hideFomentation
        v-else-if="$store.state.user.type == 2 && $store.state.user.companyType == 2"
        :url="url"
        :selected="this.$route.name"
        :availableToFomentation="$store.state.user.availableToFomentation"
        :hasBuyerValidation="$store.state.user.availableToXmlAnticipation"
        :openValidations="$store.state.user.openValidations"
        :openRequestsAnticipation="$store.state.user.openRequestsAnticipation"
        :availableToRequestValueForAnticipation="$store.state.user.availableToRequestValueForAnticipation"
    >
        <component :is="logos[getWhiteLabel]" />
        <PoweredBy v-if="getWhiteLabel === 'TECBAN'" stroke="none" />
    </BuyerSidebar>

    <SponsorBuyerSidebar
        v-else-if="$store.state.user.type == 0 && $store.state.user.companyType == 2"
        :url="url"
        :selected="this.$route.name"
    >
        <component :is="logos[getWhiteLabel]" />
        <PoweredBy v-if="getWhiteLabel === 'TECBAN'" stroke="none" />
    </SponsorBuyerSidebar>

    <main :class="`${getPrimaryColor} ${$store.state.tabs.collapse ? 'menu-collapsed' : ''}`" class="dark">
        <NavbarDefault :logged="true" />
        <DownloadLoadingCard v-if="$store.state.user.isDownloadLoading" />
        <router-view></router-view>
    </main>

    <RequestFinancing
        :value="requestFinancigValue"
        :title="requestFinancigTitle"
        :dialogVisible="dialogVisibleRequestFinancing"
        @closeModal="dialogVisibleRequestFinancing = $event"
        @request="dialogVisibleRequestedFinancing = true; dialogVisibleRequestFinancing = false"
    />

    <RequestedFinancingUnderReview
        :dialogVisible="dialogVisibleRequestedFinancing"
        title="Como funcionam os contratos e projetos?"
        buttonLabel="Ver pedidos"
        @closeModal="dialogVisibleRequestedFinancing = $event"
    />
    
    <OnboardingMenu :url="url" :buttonVisibleRoutes="buttonVisibleRoutes"/>
    <FullLoading :color="getPrimaryColorHex.five" />

    <div class="fundo-apagado" v-if="!$store.state.tabs.collapse" @click="closeMenu"></div>
</div>
</template>

<script>
import NavbarDefault from '@/components/navigation/navbar/NavbarDefault'
import RequestFinancing from '@/components/modals/RequestFinancing'
import RequestedFinancingUnderReview from '@/components/modals/RequestedFinancingUnderReview'
import FullLoading from '@/components/loading/FullLoading'
import onboardingMenuConfig from '@/utils/onboardingMenuConfig'
import DownloadLoadingCard from '@/components/loading/DownloadLoadingCard'
import PoweredBy from '@/components/icons/PoweredBy'
import LogoTecban from '@/components/icons/LogoTecban'
import LogoCiabraByCashforce from '@/components/icons/LogoCiabraByCashforce'
import LogoFMS from '@/components/icons/LogoFMS'
import LogoCashforce from '@/components/icons/LogoCashforce'
import LogoNetmoney from '@/components/icons/LogoNetmoney'
import LogoViaInvest from '@/components/icons/LogoViaInvest'
import LogoM7 from '@/components/icons/LogoM7'
import LogoIntrabank from '@/components/icons/LogoIntrabank'
import LogoIriom from '@/components/icons/LogoIriom.vue'
import LogoBiz2bank from '@/components/icons/LogoBiz2bank.vue'
import LogoSomosPremium from '@/components/icons/LogoSomosPremium.vue'
import LogoCarbon from '@/components/icons/LogoCarbon.vue'
import LogoAmb from '@/components/icons/LogoAmb.vue'
import LogoMGpay from '@/components/icons/LogoMGpay.vue'
import LogoUniverso from '@/components/icons/LogoUniverso.vue'
import LogoSomma from '@/components/icons/LogoSomma.vue'


export default {
    components: {
    NavbarDefault,
    RequestFinancing,
    RequestedFinancingUnderReview,
    FullLoading,
    DownloadLoadingCard,
    PoweredBy,
    LogoTecban,
    LogoCiabraByCashforce,
    LogoFMS,
    LogoNetmoney,
    LogoViaInvest,
    LogoM7,
    LogoIntrabank,
    LogoIriom,
    LogoBiz2bank,
    LogoSomosPremium,
    LogoCarbon,
    LogoAmb,
    LogoMGpay,
    LogoUniverso,
    LogoSomma,
},
    data() {
        return {
            dialogVisibleRequestFinancing: false,
            dialogVisibleRequestedFinancing: false,
            requestFinancigValue: 0,
            requestFinancigTitle: '',
            url: {},
            buttonVisibleRoutes: onboardingMenuConfig.showRoutes,
            logos: {
                'CASHFORCE': LogoCashforce,
                'TECBAN': LogoTecban,
                'FUNDO MULTI SUPERMERCADOS': LogoFMS,
                'CIABRA': LogoCiabraByCashforce,
                'NETMONEY': LogoNetmoney,
                'OS INTELIGENCIA FINANCEIRA': LogoCashforce,
                'POE NA TELA': LogoCashforce,
                'VIA INVEST': LogoViaInvest,
                'M7': LogoM7,
                'INTRABANK': LogoIntrabank,
                'IRIOM': LogoIriom,
                'BIZ2BANK': LogoBiz2bank,
                'TRIAL': LogoCashforce,
                'SOMOS PREMIUM': LogoSomosPremium,
                'CARBON': LogoCarbon,
                'AMB': LogoAmb,
                'MGPAY': LogoMGpay,
                'UNIVERSO': LogoUniverso,
                'SOMMA': LogoSomma,
                'TRIAL 2': LogoCashforce,
                'TRIAL 3': LogoCashforce,
            }
        }

    },
    methods: {
        handleFinancingDialog(title) {
            this.requestFinancigTitle = title;
            this.dialogVisibleRequestFinancing = true
        },
        closeMenu() {
            this.$store.commit('tabs/setCollapse', true)
        }
    },
    created() {
        this.url = {
            urlClient: this.getServiceUrls.CLIENT,
            urlMarketplace: this.getServiceUrls.MARKETPLACE,
            urlFomentation: this.getServiceUrls.FOMENTATION
        }
    },
}
</script>

<style>

</style> 
